import { notificationsMixin } from './notifications';

/**
 * Mixin zakładek
 *
 */
export const stepperMixin = {
  mixins: [notificationsMixin],
  data() {
    return { activeStep: 0, steps: [] };
  },
  methods: {
    // @vuese
    // Ustawia krok, jeżeli aktualna sekcja nie ma błędów
    setStep(step) {
      if (step >= this.activeStep) {
        const errors = this.validateStep(this.activeStep);
        if (errors.length) {
          this.notifyError('Należy poprawić błędy formularza.');
          return;
        }
      }
      this.activeStep = step;
    },
    // @vuese
    // Walidacja sekcji
    validateStep(stepToCheck) {
      let stepComponent = null;
      for (let i = 0; i < this.$children.length; i++) {
        const component = this.$children[i];
        if (isComponent(component, 'StepperStep', 'stepper-step')) {
          if (component.step === stepToCheck) {
            stepComponent = component;
            break;
          }
        }
      }

      if (!stepComponent) {
        return [];
      }

      const result = [];
      traverseError(stepComponent, result);
      return result;
    }
  }
};

/**
 * Sprawdza czy elemnt jest odpowiednim komponentem
 *
 * @param {*} component
 * @param {string} className
 * @param {string} tagName
 * @returns {boolean}
 */
function isComponent(component, className, tagName) {
  let Ctor = component.$vnode.componentOptions.Ctor;
  if (Ctor && Ctor.extendOptions && (Ctor.extendOptions.name === className || Ctor.extendOptions.name === tagName)) {
    return true;
  } else {
    if (component.$vnode.componentOptions.tag === tagName) {
      return true;
    }
  }
  return false;
}

/**
 * Sprawdza czy komponent lub jego dzieci mają błędy
 *
 * @param {*} parentComponent
 * @param {any[]} result
 */
function traverseError(parentComponent, result) {
  if (parentComponent.model && parentComponent.model.$validate) {
    const validationResult = parentComponent.model.$validate();
    if (validationResult) {
      result.push(parentComponent);
    }
  }

  if (parentComponent.$children) {
    const childrenLength = parentComponent.$children.length;
    for (let i = 0; i < childrenLength; i++) {
      traverseError(parentComponent.$children[i], result);
    }
  }
}
